import React, { useState, useEffect } from "react";
import TableComponent from "../../components/tableComponent/AdminTableComponent";
import Modals from "../../components/common/Modal";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Card, Modal } from "react-bootstrap";
import {
  AiOutlineFile,
  AiOutlineFileImage,
  AiOutlineFilePdf,
  AiOutlineFileText,
} from "react-icons/ai";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  createEditApiStatussptf,
  createSptfAction,
  getExportData,
  getExportDataApiCall,
  getExportDataForView,
  getExportDataForViewApiCall,
  getDocumentByIdActionSuccess,
  createSptfDisable,
  getAllAuctionCenterAction,
  getMark,
  FactoryOwnerList,
  FactoryList,
  searchRequest,
  getSptfRecoveryRequest,
  updateSptfRecoveryRequest,
  deleteSptfRecoveryRequest,
} from "../../store/actions";
import UploadMultipleDocuments from "../uploadDocument/UploadMultipleDocuments";
import $ from "jquery";
import { uploadedFileDownload } from "../uploadDocument/UploadedFileDownload";
import CustomToast from "../../components/Toast";
import Base64ToExcelDownload from "../Base64ToExcelDownload";
import Base64ToPDFPreview from "../uploadDocument/Base64ToPDFPreview";
import { NO_OF_RECORDS } from "../../constants/commonConstants";
import { Tooltip } from "@mui/material";
import { ThreeDots } from "react-loader-spinner";

let pageNo = 1;
function CreateSptf({ open, setOpen, modalRight }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [auctionCenterId, setauctionCenterId] = useState("");
  const [auctionCenterIdName, setauctionCenterName] = useState("");

  const [factoryOwnerId, setfactoryOwnerId] = useState("");
  const [sptfrecoveryid, setsptfrecoveryid] = useState("");
  const [factoryId, setfactoryId] = useState("");
  const [markId, setmarkId] = useState("");
  const [referenceNumber, setreferenceNumber] = useState("");
  const [sftpRecoveryAmount, setsftpRecoveryAmount] = useState("");
  const [remarks, setremarks] = useState("");

  const [auctionCenterIdNameV, setauctionCenterNameV] = useState("");
  const [factoryOwnerIdV, setfactoryOwnerIdV] = useState("");
  const [factoryIdV, setfactoryIdV] = useState("");
  const [markIdV, setmarkIdV] = useState("");
  const [referenceNumberV, setreferenceNumberV] = useState("");
  const [sftpRecoveryAmounV, setsftpRecoveryAmountV] = useState("");
  const [remarksV, setremarksV] = useState("");

  const [markIdError, setmarkIdError] = useState("");
  const [sftpRecoveryAmountError, setsftpRecoveryAmountError] = useState("");
  const [remarksError, setremarksError] = useState("");
  const [referenceNumberError, setreferenceNumberError] = useState("");
  const [userIdError, setuserIdError] = useState("");
  const [factoryIdError, setfactoryIdError] = useState("");
  const [stateName, setStateName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);
  const [stateCode, setStateCode] = useState();
  const [stateInitial, setStateInitial] = useState("");
  const [uploadDocumentRemarks, setUploadDocumentRemarks] = useState("");
  const [editingSptfData, seteditingSptfData] = useState(null);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [auctionCenterIdError, setauctionCenterIdError] = useState("");
  const [status, setStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [exportViewType, setexportViewType] = useState("");
  const [isActive, setIsActive] = useState("");

  const [uploadDocumentError, setUploadDocumentError] = useState("");
  const [expanded, setExpanded] = useState("panel1");
  const [showmodal, setShowmodal] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [exportType, setexportType] = useState("");
  const [documentMode, setDocumentmode] = useState("");
  const [previewModal, setPreviewModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [EditActive, setEditActive] = useState(false);
  const [previewDocumentContent, setPreviewDocumentContent] = useState("");

  const FactoryOwner = useSelector(
    (state) => state?.Sptf?.getSptfSuccess?.responseData
  );
  console.log("FactoryOwner", FactoryOwner);
  const getAllFactoryData = useSelector(
    (state) => state.Sptf?.getSptfListSuccess?.responseData
  );

  const getMarkData = useSelector(
    (state) => state.markReducer?.getMark?.responseData
  );
  console.log("getAllFactoryData160", getAllFactoryData);
  const getAllAuctionCenterResponse = useSelector(
    (state) => state.auctionCenter?.getAllAuctionCenter?.responseData
  );

  const searchDataSptf = useSelector((state) => state.Sptf.searchData);
  const idData = useSelector((state) => state.Sptf.sptfRecoveryData);
  const idDataExcel = useSelector(
    (state) => state.Sptf?.sptfRecoveryData?.responseData
  );
  const idDataEdit = useSelector((state) => state.Sptf.sptfRecoveryData);
  console.log(idData, "idDataidData");
  const createSptfData = useSelector(
    (state) => state.Sptf.createSptfListSuccess
  );
  // console.log(searchDataSptf1,"searchDataSptf")
  console.log(createSptfData, "searchDataSptfsearchDataSptf");

  const getAllAuctionCenter =
    getAllAuctionCenterResponse &&
    getAllAuctionCenterResponse.filter((data) => 1 == data.isActive);

  const resetForm = () => {
    setauctionCenterId("");
    setfactoryOwnerId("");
    setsptfrecoveryid("");
    setfactoryId("");
    setmarkId("");
    setreferenceNumber("");
    setsftpRecoveryAmount("");
    setremarks("");
    setauctionCenterIdError("");
    setfactoryIdError("");
    setuserIdError("");
    setmarkIdError("");
    setremarksError("");
    setreferenceNumberError("");
    setsftpRecoveryAmountError("");
    setUploadedDocuments([]);
    const inputElement = document.getElementById("stateUpload");
    if (inputElement) {
      inputElement.value = "";
    }
    setUploadedFiles([]); // Clear uploaded files
  };

  const handleClear = () => {
    resetForm();
  };

  useEffect(() => {
    if (idDataEdit) {
      setauctionCenterId(idDataEdit?.responseData.auctionCenterId);
      setfactoryOwnerId(idDataEdit?.responseData.factoryOwnerId);
      setsptfrecoveryid(idDataEdit?.responseData.sptfrecoveryid);
      if (idDataEdit?.responseData.factoryOwnerId) {
        dispatch(
          FactoryList({
            isActive: 1,
            userId: idDataEdit?.responseData?.factoryOwnerId,
          })
        );
      }
      if (idDataEdit?.responseData.factoryId) {
        dispatch(
          getMark({
            isActive: 1,
            factoryId: idDataEdit?.responseData.factoryId,
          })
        );
      }
      setfactoryId(idDataEdit?.responseData?.factoryId);
      setmarkId(idDataEdit?.responseData?.markId);
      setreferenceNumber(idDataEdit?.responseData?.referenceNumber);
      setsftpRecoveryAmount(idDataEdit?.responseData?.sftpRecoveryAmount);
      setremarks(idDataEdit?.responseData?.remarks);
    }
  }, [idDataEdit]);
  useEffect(() => {
    if (createSptfData?.data?.statusCode === 200) {
      console.log(
        createSptfData?.data?.statusCode,
        "createSptfData?.data?.statusCode"
      );
      handleClear();
      setExpanded("panel2");
      dispatch(searchRequest({}));
    }
  }, [createSptfData]);
  useEffect(() => {
    if (idData) {
      setauctionCenterNameV(idData?.responseData?.auctionCenterName);
      setfactoryOwnerIdV(idData?.responseData?.factoryOwnerName);
      setfactoryIdV(idData?.responseData?.factoryName);
      setmarkIdV(idData?.responseData?.markName);
      setreferenceNumberV(idData?.responseData?.referenceNumber);
      setsftpRecoveryAmountV(idData?.responseData?.sftpRecoveryAmount);
      setremarksV(idData?.responseData?.remarks);
    }
  }, [idData]);

  const clearSearch = () => {
    setIsActive("");
    // setRows([]);
    pageNo = 1;
    setLoader(true);
    dispatch(
      getAllAuctionCenterAction({
        isActive: 1,
      })
    );
  };
  useEffect(() => {
    dispatch(getAllAuctionCenterAction({}));
    dispatch(searchRequest({}));
  }, []);
  const clearSearchpage = () => {
    setToDate("");
    setFromDate("");
    setStatus("");
    setIsActive("");
    setreferenceNumber("");
    setmarkId("");
    setfactoryId("");
    setfactoryOwnerId("");
    setauctionCenterId("");
    setRows([]);
    pageNo = 1;
    setLoader(true);
    dispatch(
      getAllAuctionCenterAction({
        isActive: 1,
      })
    );
    dispatch(searchRequest({}));
  };
  const handleUpdate = () => {
    // Check if the form has been modified
    const newSptfData = {
      auctionCenterId: auctionCenterId,
      factoryOwnerId: factoryOwnerId,
      markId: markId,
      factoryId: factoryId,
      referenceNumber: referenceNumber,
      sftpRecoveryAmount: sftpRecoveryAmount,
      remarks: remarks,
      isActive: 1,
      downloadDto: null,
      uploadDocumentRemarks: null,
      cstatus: 0,
      sptfrecoveryid: sptfrecoveryid,
    };

    // Update the editingSptfData with new values
    // editingSptfData.uploadDocumentRemarks = uploadDocumentRemarks;
    // editingSptfData.downloadDto = uploadedDocuments;

    // Dispatch update action
    dispatch(updateSptfRecoveryRequest(newSptfData));

    setLoader(true);
    setRows([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Reset previous validation errors
    setauctionCenterIdError("");
    setfactoryIdError("");
    setuserIdError("");
    setmarkIdError("");
    setremarksError("");
    setreferenceNumberError("");
    setsftpRecoveryAmountError("");

    // Perform form validation
    let isValid = true;

    if (!auctionCenterId.trim()) {
      isValid = false;
      CustomToast.error("Please select Auction Center");
      return;
    }

    if (!factoryOwnerId) {
      CustomToast.error("Please select Factory Owner/Seller");
      isValid = false;
      return;
    }

    if (!factoryId.trim()) {
      CustomToast.error("Please select Factory");
      isValid = false;
      return;
    }
    if (!markId.trim()) {
      CustomToast.error("Please select Mark");
      isValid = false;
      return;
    }
    if (!referenceNumber.trim()) {
      CustomToast.error("Please enter Reference Number.");
      isValid = false;
      return;
    }
    if (!sftpRecoveryAmount.trim()) {
      CustomToast.error("Please enter SPTF Recovery Amount.");
      isValid = false;
      return;
    }
    if (!remarks.trim()) {
      CustomToast.error("Please enter Remarks.");
      isValid = false;
      return;
    }
    if (!isValid) {
      return;
    }
    setIsSubmitting(true);
    setTimeout(() => {
      const newSptfData = {
        auctionCenterId: auctionCenterId,
        factoryOwnerId: factoryOwnerId,
        markId: markId,
        factoryId: factoryId,
        referenceNumber: referenceNumber,
        sftpRecoveryAmount: sftpRecoveryAmount,
        remarks: remarks,
        isActive: 1,
        downloadDto: null,
        uploadDocumentRemarks: null,
        cstatus: 0,
      };

      try {
        if (editingSptfData) {
          const isFormModified =
            auctionCenterId !== editingSptfData.auctionCenterId ||
            factoryOwnerId !== editingSptfData.factoryOwnerId ||
            markId !== editingSptfData.markId ||
            factoryId !== editingSptfData.factoryId ||
            referenceNumber !== editingSptfData.referenceNumber ||
            sftpRecoveryAmount !== editingSptfData.sftpRecoveryAmount ||
            remarks !== editingSptfData.remarks ||
            uploadedDocuments.length !== editingSptfData.downloadDto.length;

          if (isFormModified) {
            editingSptfData.uploadDocumentRemarks = uploadDocumentRemarks;
            editingSptfData.downloadDto = uploadedDocuments;

            setLoader(true);
            setRows([]);
            // dispatch(updateStateAction(editingSptfData));
          } else {
            handleClear();

            setExpanded("panel2");
          }
        } else {
          setLoader(true);
          setRows([]);
          dispatch(createSptfAction(newSptfData));
          // handleClear();

          // setExpanded("panel2");
        }
      } catch (error) {}
      setIsSubmitting(false);
    }, 500);
  };
  const ApiDataState = useSelector((state) => state?.state?.StateLoader);

  useEffect(() => {
    if (true == ApiDataState) {
      setTimeout(() => {
        setLoader(false);
        pageNo = pageNo;
      }, 1000);
    }
  });
  let createdisable = useSelector((state) => state.Sptf?.createSptfDisable);

  useEffect(() => {
    if (true == createdisable) {
      setIsSubmitting(false);
    }
  });

  let createData = useSelector((state) => state.Sptf?.createEditSptf);

  useEffect(() => {
    if (true == createData && createdisable) {
      dispatch(createEditApiStatussptf(false));
      dispatch(createSptfDisable(false));
      setExpanded("panel2");
      handleClear();
      setIsSubmitting(false);
      seteditingSptfData(null);
      setEditModal(false);
      setViewModal(false);
    } else if (true == createData) {
      dispatch(createEditApiStatussptf(false));
      // handleCloseEditModal();
      setExpanded("panel2");
      handleClear();
      setIsSubmitting(false);
      seteditingSptfData(null);
      setEditModal(false);
      setViewModal(false);
      if (!EditActive) {
        handleCloseEditModal();
      }
      setEditActive(false);
    }
  });

  useEffect(() => {
    if (auctionCenterId) {
      dispatch(
        FactoryOwnerList({
          auctionCenterId: auctionCenterId,
          roleCode: "SELLER",
        })
      );
    }
  }, [auctionCenterId, dispatch]);

  const handleAuctionCenterChange = (e) => {
    const newAuctionCenterId = e.target.value;
    if (!viewMode) {
      if (editingSptfData) {
        seteditingSptfData({
          ...editingSptfData,
          auctionCenterId: newAuctionCenterId,
        });
      } else {
        setauctionCenterId(newAuctionCenterId);
      }
    }
  };
  const handleUserChange = (e) => {
    const selectedUserId = e.target.value;
    setfactoryOwnerId(selectedUserId); // Set the selected user ID
    if (selectedUserId) {
      // Only dispatch when a user is selected
      dispatch(
        FactoryList({
          isActive: 1,
          userId: selectedUserId,
        })
      );
    }
  };
  const handleFactoryChange = (e) => {
    const selectedFactoryId = e.target.value;
    setfactoryId(selectedFactoryId);
    if (selectedFactoryId) {
      dispatch(
        getMark({
          isActive: 1,
          factoryId: selectedFactoryId,
        })
      );
    }
  };

  const handleCloseHistory = () => setShowmodal(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    if ("panel2" == panel && isExpanded) {
      //Serch API call
      // dispatch(searchStateAction({}));
      dispatch(searchRequest({}));

      //Get All State
      setIsSubmitting(false);
      clearSearch();
      setViewMode(false);
      seteditingSptfData(null);
      handleClear();
    } else if ("panel3" == panel && isExpanded) {
      //Document API call
      setIsSubmitting(false);
      setViewMode(false);
      seteditingSptfData(null);
      handleClear();
    } else if ("panel1" == panel && !isExpanded) {
      setViewMode(false);
      setIsSubmitting(false);
      seteditingSptfData(null);
      handleClear();
    }
  };

  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (searchDataSptf && searchDataSptf.responseData) {
      setRows((prevRows) => {
        const currentRows = Array.isArray(prevRows) ? [...prevRows] : [];

        searchDataSptf.responseData.forEach((newRow) => {
          const index = currentRows.findIndex(
            (row) => row.sptfrecoveryid === newRow.sptfrecoveryid
          );

          if (index !== -1) {
            currentRows[index] = newRow;
          } else {
            currentRows.push(newRow);
          }
        });

        return currentRows;
      });
    }
  }, [searchDataSptf]);
  const handleEditClick = (stateId) => {
    console.log(stateId, "datadatadata");

    dispatch(getSptfRecoveryRequest(stateId));
    setViewMode(false);
    // setExpanded("panel1");
    setEditModal(true);
  };
  const handleViewClick = (stateId) => {
    dispatch(getSptfRecoveryRequest(stateId));

    setViewMode(true);
    // setExpanded("panel1"); // Assuming this is to expand the appropriate accordion
    setViewModal(true);
  };
  const handleDeleteClick = (stateId) => {
    dispatch(deleteSptfRecoveryRequest(stateId));
    setTimeout(() => {
      dispatch(searchRequest({}));
    }, 1000); // 1000 milliseconds = 1 second
  };

  const columns = [
    {
      name: "index",
      title: "Sr.",
    },
    {
      name: "auctionCenterName",
      title: "Auction Center",
    },
    {
      name: "factoryOwnerName",
      title: "Factory Owner/Seller",
    },
    {
      name: "factoryName",
      title: "Factory",
    },
    {
      name: "markName",
      title: "Mark",
    },
    {
      name: "referenceNumber",
      title: "Reference Number",
    },
    {
      name: "sftpRecoveryAmount",
      title: "Amount",
    },
    {
      name: "cstatus",
      title: "Status",
      getCellValue: (row) => {
        switch (row.cstatus) {
          case 0:
            return "Pending";
          case 1:
            return "Settled";
          case 2:
            return "Deleted";
          default:
            return "";
        }
      },
    },
    {
      name: "action",
      title: "Action",
      getCellValue: (rows) => <ActionData data={rows} />,
    },
  ];
  function ActionData(data) {
    const { cstatus } = data.data;
    return (
      <div class="Action">
        {/* {modalRight?.some((ele) => ele === "2") && ( */}
        <Tooltip title="Edit" placement="top">
          <i
            className="fa fa-edit"
            onClick={() => handleEditClick(data.data.sptfrecoveryid)}
          ></i>
        </Tooltip>
        {/* )} */}
        {/* {modalRight?.some((ele) => ele === "3") && ( */}
        <Tooltip title="View" placement="top">
          <i
            className="fa fa-eye"
            onClick={() => handleViewClick(data.data.sptfrecoveryid)}
          ></i>
        </Tooltip>
        {/* )} */}
        {/* {modalRight?.some((ele) => ele === "4") && ( */}
        {cstatus !== 2 && (
          <Tooltip title="Delete" placement="top">
            <i
              className="fa fa-trash"
              onClick={() => handleDeleteClick(data.data.sptfrecoveryid)}
            ></i>
          </Tooltip>
        )}
        {/* <Tooltip title="Delete" placement="top">
          <i
            className="fa fa-trash"
            onClick={() => handleDeleteClick(data.data.sptfrecoveryid)}
          ></i>
        </Tooltip> */}
        {/* )} */}
      </div>
    );
  }
  const handleFileUpload = (files) => {
    const newFiles = files?.map((file) => ({
      documentContent: file.documentContent,
      documentName: file.documentName,
      documentSize: file.documentSize,
    }));
    setUploadedDocuments(newFiles);
  };
  const handleClosePreviewModal = () => {
    dispatch(getDocumentByIdActionSuccess(""));
    setDocumentmode("");
    setPreviewModal(false);
    setPreviewDocumentContent("");
  };

  const handleCloseViewModal = () => {
    setViewModal(false);
    setViewMode(false);
    seteditingSptfData(null);
    // handleClear();
    setauctionCenterName("");
    setfactoryOwnerId("");
    setsptfrecoveryid("");
    dispatch(searchRequest({}));
  };

  const handleCloseEditModal = () => {
    setEditModal(false);
    setViewMode(false);
    seteditingSptfData(null);
    clearSearch();
    handleClear();
    dispatch(searchRequest({}));
  };
  const fetchData = () => {
    console.log(editingSptfData, "editingSptfDataeditingSptfData");
    dispatch(
      //   searchRequest({
      //     // stateName: searchStateName,
      //     // stateId: searchStateCode > 0 ? parseInt(searchStateCode) : "",
      //     // stateInitial: searchStateInitial,
      //     // isActive: isActive != "" ? parseInt(isActive) : isActive,
      //     // pageNo: 1,
      //     // noOfRecords: NO_OF_RECORDS,
      //     auctionCenterId: editingSptfData.auctionCenterId,
      // factoryId: editingSptfData.factoryId,
      // markId: editingSptfData.markId,
      // referenceNumber: editingSptfData.referenceNumber,
      // fromDate: editingSptfData.fromDate,
      // toDate: editingSptfData.toDate,
      // userId: editingSptfData.userId,
      //   })
      searchRequest({
        auctionCenterId: editingSptfData
          ? editingSptfData.auctionCenterId !== 0
            ? editingSptfData.auctionCenterId
            : ""
          : auctionCenterId !== 0
          ? auctionCenterId
          : "",
        factoryId: editingSptfData
          ? editingSptfData.factoryId !== 0
            ? editingSptfData.factoryId
            : ""
          : factoryId !== 0
          ? factoryId
          : "",
        markId: editingSptfData
          ? editingSptfData.markId !== 0
            ? editingSptfData.markId
            : ""
          : markId !== 0
          ? markId
          : "",

        referenceNumber: referenceNumber,
        fromDate: fromDate,
        toDate: toDate,
        cstatus: status === "settled" ? 1 : status === "pending" ? 0 : "",
        // userId: atob(sessionStorage.getItem("argument2")),
        userId: editingSptfData
          ? editingSptfData.factoryOwnerId !== 0
            ? editingSptfData.factoryOwnerId
            : ""
          : factoryOwnerId !== 0
          ? factoryOwnerId
          : "",
      })
    );
  };
  const handleSearch = () => {
    setLoader(true);
    setRows([]);
    fetchData();
  };
  const handleExport = (exportType) => {
    setexportType("");
    let searchData = {
      auctionCenterId: editingSptfData
        ? editingSptfData.auctionCenterId !== 0
          ? editingSptfData.auctionCenterId
          : ""
        : auctionCenterId !== 0
        ? auctionCenterId
        : "",
      factoryId: editingSptfData
        ? editingSptfData.factoryId !== 0
          ? editingSptfData.factoryId
          : ""
        : factoryId !== 0
        ? factoryId
        : "",
      markId: editingSptfData
        ? editingSptfData.markId !== 0
          ? editingSptfData.markId
          : ""
        : markId !== 0
        ? markId
        : "",

      referenceNumber: referenceNumber,
      fromDate: fromDate,
      toDate: toDate,
      cstatus: status === "settled" ? 1 : status === "pending" ? 0 : "",
      // userId: atob(sessionStorage.getItem("argument2")),
      userId: editingSptfData
        ? editingSptfData.factoryOwnerId !== 0
          ? editingSptfData.factoryOwnerId
          : ""
        : factoryOwnerId !== 0
        ? factoryOwnerId
        : "",
      url: "/admin/sptfrecovery/search",
      exportType: exportType,
      isExport: 1,
    };
    setexportType(exportType);
    setLoader(true);

    dispatch(getExportData(searchData));
  };
  const handleViewExport = (exportType) => {
    setexportViewType("");
    let id = idDataExcel && idDataExcel.sptfrecoveryid;
    let searchData = {
      url: `/admin/sptfrecovery/get/${id}/${exportType}`,
    };
    setexportViewType(exportType);
    setLoader(true);
    dispatch(getExportDataForView(searchData));
  };

  const getExportViewDataResponse = useSelector(
    (state) => state.documentReducer.exportViewData.responseData?.exported_file
  );

  const getExportDataViewApiCallResponse = useSelector(
    (state) => state.documentReducer.exportDataForViewApiCall
  );

  useEffect(() => {
    if (
      getExportViewDataResponse != null &&
      true == getExportDataViewApiCallResponse
    ) {
      dispatch(getExportDataForViewApiCall(false));
      if ("excel" == exportViewType) {
        Base64ToExcelDownload(getExportViewDataResponse, "SPTFDetails.xlsx");
      } else {
        uploadedFileDownload(
          getExportViewDataResponse,
          "SPTFDetails.pdf",
          `data:application/pdf;base64`
        );
      }
    }
  });

  const getExportDataResponse = useSelector(
    (state) => state.documentReducer.exportData.responseData?.exported_file
  );

  const getExportDataApiCallResponse = useSelector(
    (state) => state.documentReducer.exportDataApiCall
  );

  useEffect(() => {
    if (getExportDataResponse != null && true == getExportDataApiCallResponse) {
      dispatch(getExportDataApiCall(false));
      if ("excel" == exportType) {
        Base64ToExcelDownload(getExportDataResponse, "SPTFDetails.xlsx");
      } else {
        uploadedFileDownload(
          getExportDataResponse,
          "SPTFDetails.pdf",
          `data:application/pdf;base64`
        );
      }
    }
  });
  return (
    <>
      {/* Create */}
      {modalRight?.some((ele) => ele === "1") && (
        <Accordion
          expanded={expanded === "panel1"}
          className={`${expanded === "panel1" ? "active" : ""}`}
          onChange={handleChange("panel1")}
          TransitionProps={{ unmountOnExit: true }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Create SPTF Recovery</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div className="row">
                <div className="col-lg-12">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row align-items-end">
                        <div className="col-md-4">
                          <div className="FormGroup">
                            <label>Auction Center</label>
                            <label className="errorLabel"> * </label>
                            <select
                              className="form-control select-form"
                              value={
                                editingSptfData?.auctionCenterId ||
                                auctionCenterId
                              }
                              onChange={handleAuctionCenterChange}
                              disabled={viewMode}
                            >
                              <option value={0}>Select Auction Center</option>
                              {getAllAuctionCenter?.map((center) => (
                                <option
                                  key={center.auctionCenterId}
                                  value={center.auctionCenterId}
                                >
                                  {center.auctionCenterName}
                                </option>
                              ))}
                            </select>

                            {auctionCenterIdError && (
                              <p className="errorLabel">
                                {auctionCenterIdError}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="FormGroup">
                            <label>Factory Owner/Seller</label>
                            <label className="errorLabel"> * </label>
                            <select
                              className="form-control select-form"
                              value={editingSptfData?.id || factoryOwnerId}
                              onChange={handleUserChange}
                              disabled={!auctionCenterId}
                            >
                              <option value={0}>Select Factory Owner</option>
                              {FactoryOwner?.map((user) => (
                                <option key={user.id} value={user.id}>
                                  {user.value}
                                </option>
                              ))}
                            </select>
                            {userIdError && (
                              <p className="errorLabel">{userIdError}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="FormGroup">
                            <label>Factory</label>
                            <label className="errorLabel"> * </label>
                            <select
                              className="form-control select-form"
                              value={editingSptfData?.factoryId || factoryId}
                              onChange={handleFactoryChange}
                              disabled={!factoryOwnerId}
                            >
                              <option value={0}>Select Factory</option>
                              {getAllFactoryData?.map((factory) => (
                                <option
                                  key={factory.factoryId}
                                  value={factory.factoryId}
                                >
                                  {factory.factoryName}
                                </option>
                              ))}
                            </select>
                            {factoryIdError && (
                              <p className="errorLabel">{factoryIdError}</p>
                            )}
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="FormGroup">
                            <label>Mark</label>
                            <label className="errorLabel"> * </label>
                            <select
                              className="form-control select-form"
                              value={editingSptfData?.markId || markId}
                              onChange={(e) =>
                                !viewMode &&
                                (editingSptfData
                                  ? seteditingSptfData({
                                      ...editingSptfData,
                                      markId: e.target.value,
                                    })
                                  : setmarkId(e.target.value))
                              }
                              disabled={!factoryId}
                            >
                              <option value="">Select Mark</option>
                              {getMarkData?.map((state) => (
                                <option key={state.markId} value={state.markId}>
                                  {state.markName}
                                </option>
                              ))}
                            </select>

                            {markIdError && (
                              <p className="errorLabel">{markIdError}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="FormGroup">
                            <label>Reference Number</label>
                            <label className="errorLabel"> * </label>
                            <input
                              type="text"
                              className="form-control"
                              required
                              value={
                                editingSptfData?.referenceNumber ||
                                referenceNumber
                              }
                              onChange={(e) =>
                                !viewMode &&
                                (editingSptfData
                                  ? seteditingSptfData({
                                      ...editingSptfData,
                                      referenceNumber: e.target.value,
                                    })
                                  : setreferenceNumber(e.target.value))
                              }
                              disabled={viewMode}
                            />
                            {referenceNumberError && (
                              <p className="errorLabel">
                                {referenceNumberError}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="FormGroup">
                            <label>SPTF Recovery Amount</label>
                            <label className="errorLabel"> * </label>
                            <input
                              type="text"
                              className="form-control"
                              required
                              value={
                                editingSptfData?.sftpRecoveryAmount ||
                                sftpRecoveryAmount
                              }
                              onChange={(e) =>
                                !viewMode &&
                                (editingSptfData
                                  ? seteditingSptfData({
                                      ...editingSptfData,
                                      sftpRecoveryAmount: e.target.value,
                                    })
                                  : setsftpRecoveryAmount(e.target.value))
                              }
                              disabled={viewMode}
                            />
                            {sftpRecoveryAmountError && (
                              <p className="errorLabel">
                                {sftpRecoveryAmountError}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="FormGroup">
                            <label>Remarks</label>
                            <label className="errorLabel"> * </label>
                            <input
                              type="text"
                              className="form-control"
                              required
                              value={editingSptfData?.remarks || remarks}
                              onChange={(e) =>
                                !viewMode &&
                                (editingSptfData
                                  ? seteditingSptfData({
                                      ...editingSptfData,
                                      remarks: e.target.value,
                                    })
                                  : setremarks(e.target.value))
                              }
                              disabled={viewMode}
                            />
                            {remarksError && (
                              <p className="errorLabel">{remarksError}</p>
                            )}
                          </div>
                        </div>
                        {!viewMode ? (
                          <>
                            {/* <div className="col-md-12">
                              <UploadMultipleDocuments
                                onFileSelect={handleFileUpload}
                                uploadedFiles={uploadedFiles}
                                setUploadedFiles={setUploadedFiles}
                                uploadDocumentError={uploadDocumentError}
                                inputId="stateUpload"
                              />
                            </div> */}

                            {/* <div className="col-md-12 mt-2">
                              <textarea
                                className="form-control"
                                placeholder="Enter Remarks"
                                value={uploadDocumentRemarks}
                                onChange={(e) =>
                                  setUploadDocumentRemarks(e.target.value)
                                }
                                disabled={viewMode}
                              ></textarea>
                              {remarksError && (
                                <p
                                  className="errorLabel"
                                  style={{ color: "red" }}
                                >
                                  {remarksError}
                                </p>
                              )}
                            </div> */}
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="BtnGroup">
                      <>
                        <button
                          className="SubmitBtn"
                          onClick={handleSubmit}
                          disabled={isSubmitting}
                        >
                          Submit
                        </button>
                        <button
                          className="Clear"
                          onClick={handleClear}
                          disabled={viewMode}
                        >
                          Clear
                        </button>
                        {/* <button
                          className="SubmitBtn"
                          //   onClick={handleSubmit}
                          //   disabled={isSubmitting}
                        >
                          Upload
                        </button> */}
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}

      {/* Edit */}
      {editModal ? (
        <Modals
          title={"Edit SPTF Recovery"}
          show={editModal}
          handleClose={handleCloseEditModal}
          size="xl"
          centered
        >
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="row align-items-end">
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Auction Center</label>
                        <label className="errorLabel"> * </label>
                        <select
                          className="form-control select-form"
                          value={auctionCenterId}
                          onChange={handleAuctionCenterChange}
                          disabled={viewMode}
                        >
                          <option value={0}>Select Auction Center</option>
                          {getAllAuctionCenter?.map((center) => (
                            <option
                              key={center.auctionCenterId}
                              value={center.auctionCenterId}
                            >
                              {center.auctionCenterName}
                            </option>
                          ))}
                        </select>

                        {auctionCenterIdError && (
                          <p className="errorLabel">{auctionCenterIdError}</p>
                        )}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Factory Owner/Seller</label>
                        <label className="errorLabel"> * </label>
                        <select
                          className="form-control select-form"
                          value={factoryOwnerId}
                          onChange={handleUserChange}
                          disabled={!auctionCenterId}
                        >
                          <option value={0}>Select Factory Owner</option>
                          {FactoryOwner?.map((user) => (
                            <option key={user.id} value={user.id}>
                              {user.value}
                            </option>
                          ))}
                        </select>
                        {userIdError && (
                          <p className="errorLabel">{userIdError}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Factory</label>
                        <label className="errorLabel"> * </label>
                        <select
                          className="form-control select-form"
                          value={factoryId}
                          onChange={handleFactoryChange}
                          disabled={!factoryOwnerId}
                        >
                          <option value={0}>Select Factory</option>
                          {getAllFactoryData?.map((factory) => (
                            <option
                              key={factory.factoryId}
                              value={factory.factoryId}
                            >
                              {factory.factoryName}
                            </option>
                          ))}
                        </select>
                        {factoryIdError && (
                          <p className="errorLabel">{factoryIdError}</p>
                        )}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Mark</label>
                        <label className="errorLabel"> * </label>
                        <select
                          className="form-control select-form"
                          value={markId}
                          onChange={(e) =>
                            !viewMode &&
                            (editingSptfData
                              ? seteditingSptfData({
                                  ...editingSptfData,
                                  markId: e.target.value,
                                })
                              : setmarkId(e.target.value))
                          }
                          disabled={!factoryId}
                        >
                          <option value={0}>Select Mark</option>
                          {getMarkData?.map((state) => (
                            <option key={state.markId} value={state.markId}>
                              {state.markName}
                            </option>
                          ))}
                        </select>

                        {markIdError && (
                          <p className="errorLabel">{markIdError}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Reference Number</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          value={
                            editingSptfData?.referenceNumber || referenceNumber
                          }
                          onChange={(e) =>
                            !viewMode &&
                            (editingSptfData
                              ? seteditingSptfData({
                                  ...editingSptfData,
                                  referenceNumber: e.target.value,
                                })
                              : setreferenceNumber(e.target.value))
                          }
                          disabled={viewMode}
                        />
                        {referenceNumberError && (
                          <p className="errorLabel">{referenceNumberError}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>SPTF Recovery Amount</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          value={
                            editingSptfData?.sftpRecoveryAmount ||
                            sftpRecoveryAmount
                          }
                          onChange={(e) =>
                            !viewMode &&
                            (editingSptfData
                              ? seteditingSptfData({
                                  ...editingSptfData,
                                  sftpRecoveryAmount: e.target.value,
                                })
                              : setsftpRecoveryAmount(e.target.value))
                          }
                          disabled={viewMode}
                        />
                        {sftpRecoveryAmountError && (
                          <p className="errorLabel">
                            {sftpRecoveryAmountError}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Remarks</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          value={editingSptfData?.remarks || remarks}
                          onChange={(e) =>
                            !viewMode &&
                            (editingSptfData
                              ? seteditingSptfData({
                                  ...editingSptfData,
                                  remarks: e.target.value,
                                })
                              : setremarks(e.target.value))
                          }
                          disabled={viewMode}
                        />
                        {remarksError && (
                          <p className="errorLabel">{remarksError}</p>
                        )}
                      </div>
                    </div>
                    {!viewMode ? (
                      <>
                        {/* <div className="col-md-12">
                          <UploadMultipleDocuments
                            onFileSelect={handleFileUpload}
                            uploadedFiles={uploadedFiles}
                            setUploadedFiles={setUploadedFiles}
                            uploadDocumentError={uploadDocumentError}
                            inputId="stateUpload"
                          />
                        </div> */}

                        {/* <div className="col-md-12 mt-2">
                          <textarea
                            className="form-control"
                            placeholder="Enter Remarks"
                            value={uploadDocumentRemarks}
                            onChange={(e) =>
                              setUploadDocumentRemarks(e.target.value)
                            }
                            disabled={viewMode}
                          ></textarea>
                          {remarksError && (
                            <p className="errorLabel" style={{ color: "red" }}>
                              {remarksError}
                            </p>
                          )}
                        </div> */}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="BtnGroup">
              <button
                className="SubmitBtn"
                onClick={handleUpdate}
                disabled={viewMode}
              >
                Update
              </button>
            </div>
          </div>
        </Modals>
      ) : (
        ""
      )}

      {/* View */}
      {viewModal ? (
        <Modals
          title={"View SPTF Recovery"}
          show={viewModal}
          handleClose={handleCloseViewModal}
          size="xl"
          centered
        >
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="row align-items-end">
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Auction Center</label>
                        <label className="errorLabel"> * </label>

                        <input
                          type="text"
                          className="form-control"
                          maxLength="50"
                          // value={categoryName}
                          // onChange={(e) => setCategoryName(e.target.value)}
                          value={auctionCenterIdNameV}
                          disabled={viewMode}
                        />
                        {auctionCenterIdError && (
                          <p className="errorLabel">{auctionCenterIdError}</p>
                        )}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Factory Owner/Seller</label>
                        <label className="errorLabel"> * </label>
                        <input
                          className="form-control select-form"
                          value={factoryOwnerIdV}
                          disabled={viewMode}
                        />

                        {userIdError && (
                          <p className="errorLabel">{userIdError}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Factory</label>
                        <label className="errorLabel"> * </label>
                        <input
                          className="form-control select-form"
                          value={factoryIdV}
                          // onChange={handleFactoryChange}
                          disabled={viewMode}
                        />

                        {factoryIdError && (
                          <p className="errorLabel">{factoryIdError}</p>
                        )}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Mark</label>
                        <label className="errorLabel"> * </label>
                        <input
                          className="form-control select-form"
                          value={markIdV}
                          // onChange={(e) =>
                          //   !viewMode &&
                          //   (editingSptfData
                          //     ? seteditingSptfData({
                          //         ...editingSptfData,
                          //         markId: e.target.value,
                          //       })
                          //     : setmarkId(e.target.value))
                          // }
                          disabled={viewMode}
                        />

                        {markIdError && (
                          <p className="errorLabel">{markIdError}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Reference Number</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          value={referenceNumberV}
                          disabled={viewMode}
                        />
                        {referenceNumberError && (
                          <p className="errorLabel">{referenceNumberError}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>SPTF Recovery Amount</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          value={sftpRecoveryAmounV}
                          // onChange={(e) =>
                          //   !viewMode &&
                          //   (editingSptfData
                          //     ? seteditingSptfData({
                          //         ...editingSptfData,
                          //         sftpRecoveryAmount: e.target.value,
                          //       })
                          //     : setsftpRecoveryAmount(e.target.value))
                          // }
                          disabled={viewMode}
                        />
                        {sftpRecoveryAmountError && (
                          <p className="errorLabel">
                            {sftpRecoveryAmountError}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Remarks</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          value={remarksV}
                          // onChange={(e) =>
                          //   !viewMode &&
                          //   (editingSptfData
                          //     ? seteditingSptfData({
                          //         ...editingSptfData,
                          //         remarks: e.target.value,
                          //       })
                          //     : setremarks(e.target.value))
                          // }
                          disabled={viewMode}
                        />
                        {remarksError && (
                          <p className="errorLabel">{remarksError}</p>
                        )}
                      </div>
                    </div>
                    {!viewMode ? (
                      <>
                        {/* <div className="col-md-12">
                          <UploadMultipleDocuments
                            onFileSelect={handleFileUpload}
                            uploadedFiles={uploadedFiles}
                            setUploadedFiles={setUploadedFiles}
                            uploadDocumentError={uploadDocumentError}
                            inputId="stateUpload"
                          />
                        </div> */}

                        {/* <div className="col-md-12 mt-2">
                          <textarea
                            className="form-control"
                            placeholder="Enter Remarks"
                            value={uploadDocumentRemarks}
                            onChange={(e) =>
                              setUploadDocumentRemarks(e.target.value)
                            }
                            disabled={viewMode}
                          ></textarea>
                          {remarksError && (
                            <p className="errorLabel" style={{ color: "red" }}>
                              {remarksError}
                            </p>
                          )}
                        </div> */}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="BtnGroup">
              {modalRight?.some((ele) => ele === "11") && (
                <button
                  class="SubmitBtn"
                  onClick={() => handleViewExport("excel")}
                >
                  <i class="fa fa-file-excel"></i>
                </button>
              )}
              {modalRight?.some((ele) => ele === "10") && (
                <button
                  class="SubmitBtn"
                  onClick={() => handleViewExport("pdf")}
                >
                  <i class="fa fa-file-pdf"></i>
                </button>
              )}
            </div>
          </div>
        </Modals>
      ) : (
        ""
      )}

      {/* Manage & Search */}
      {modalRight?.some((ele) => ele === "12") && (
        <Accordion
          expanded={expanded === "panel2"}
          className={`${expanded === "panel2" ? "active" : ""}`}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>Manage SPTF Recovery</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div className="row">
                <div className="col-lg-12">
                  <div className="row align-items-end">
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Auction Center</label>
                        <label className="errorLabel"> * </label>
                        <select
                          className="form-control select-form"
                          value={
                            editingSptfData?.auctionCenterId || auctionCenterId
                          }
                          onChange={handleAuctionCenterChange}
                          disabled={viewMode}
                        >
                          <option value={0}>Select Auction Center</option>
                          {getAllAuctionCenter?.map((center) => (
                            <option
                              key={center.auctionCenterId}
                              value={center.auctionCenterId}
                            >
                              {center.auctionCenterName}
                            </option>
                          ))}
                        </select>

                        {auctionCenterIdError && (
                          <p className="errorLabel">{auctionCenterIdError}</p>
                        )}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Factory Owner/Seller</label>
                        <label className="errorLabel"> * </label>
                        <select
                          className="form-control select-form"
                          value={editingSptfData?.id || factoryOwnerId}
                          onChange={handleUserChange}
                          disabled={!auctionCenterId}
                        >
                          <option value={0}>Select Factory Owner</option>
                          {FactoryOwner?.map((user) => (
                            <option key={user.id} value={user.id}>
                              {user.value}
                            </option>
                          ))}
                        </select>
                        {userIdError && (
                          <p className="errorLabel">{userIdError}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Factory</label>
                        <label className="errorLabel"> * </label>
                        <select
                          className="form-control select-form"
                          value={editingSptfData?.factoryId || factoryId}
                          onChange={handleFactoryChange}
                          disabled={!factoryOwnerId}
                        >
                          <option value={0}>Select Factory</option>
                          {getAllFactoryData?.map((factory) => (
                            <option
                              key={factory.factoryId}
                              value={factory.factoryId}
                            >
                              {factory.factoryName}
                            </option>
                          ))}
                        </select>
                        {factoryIdError && (
                          <p className="errorLabel">{factoryIdError}</p>
                        )}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Mark</label>
                        <label className="errorLabel"> * </label>
                        <select
                          className="form-control select-form"
                          value={editingSptfData?.markId || markId}
                          onChange={(e) =>
                            !viewMode &&
                            (editingSptfData
                              ? seteditingSptfData({
                                  ...editingSptfData,
                                  markId: e.target.value,
                                })
                              : setmarkId(e.target.value))
                          }
                          disabled={!factoryId}
                        >
                          <option value={0}>Select Mark</option>
                          {getMarkData?.map((state) => (
                            <option key={state.markId} value={state.markId}>
                              {state.markName}
                            </option>
                          ))}
                        </select>

                        {markIdError && (
                          <p className="errorLabel">{markIdError}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Reference Number</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          value={
                            editingSptfData?.referenceNumber || referenceNumber
                          }
                          onChange={(e) =>
                            !viewMode &&
                            (editingSptfData
                              ? seteditingSptfData({
                                  ...editingSptfData,
                                  referenceNumber: e.target.value,
                                })
                              : setreferenceNumber(e.target.value))
                          }
                          disabled={viewMode}
                        />
                        {referenceNumberError && (
                          <p className="errorLabel">{referenceNumberError}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>From Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>To Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="FormGroup">
                        <label>Status</label>
                        <select
                          className="form-control select-form"
                          value={status}
                          onChange={(e) => setStatus(e.target.value)}
                        >
                          <option value="">Please select status</option>
                          <option value="pending">Pending</option>
                          <option value="settled">Settled</option>
                        </select>
                      </div>
                    </div>

                    {!viewMode ? (
                      <>
                        {/* <div className="col-md-12">
                          <UploadMultipleDocuments
                            onFileSelect={handleFileUpload}
                            uploadedFiles={uploadedFiles}
                            setUploadedFiles={setUploadedFiles}
                            uploadDocumentError={uploadDocumentError}
                            inputId="stateUpload"
                          />
                        </div> */}

                        {/* <div className="col-md-12 mt-2">
                          <textarea
                            className="form-control"
                            placeholder="Enter Remarks"
                            value={uploadDocumentRemarks}
                            onChange={(e) =>
                              setUploadDocumentRemarks(e.target.value)
                            }
                            disabled={viewMode}
                          ></textarea>
                          {remarksError && (
                            <p className="errorLabel" style={{ color: "red" }}>
                              {remarksError}
                            </p>
                          )}
                        </div> */}
                      </>
                    ) : (
                      ""
                    )}

                    <div className="col-md-12">
                      <div className="BtnGroup">
                        <button
                          className="SubmitBtn"
                          onClick={() => handleSearch()}
                        >
                          Search
                        </button>
                        <button className="Clear" onClick={clearSearchpage}>
                          Clear
                        </button>
                        {modalRight?.some((ele) => ele === "9") && (
                          <button
                            class="SubmitBtn"
                            onClick={() => handleExport("excel")}
                          >
                            <i class="fa fa-file-excel"></i>
                          </button>
                        )}
                        {modalRight?.some((ele) => ele === "8") && (
                          <button
                            class="SubmitBtn"
                            onClick={() => handleExport("pdf")}
                          >
                            <i class="fa fa-file-pdf"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 mt-4">
                  <div className="TableBox CreateStateMaster">
                    {rows?.length > 0 ? (
                      <TableComponent
                        columns={columns}
                        rows={rows?.map((row, index) => ({
                          ...row,
                          index: index + 1,
                        }))}
                        sorting={true}
                        dragdrop={false}
                        fixedColumnsOn={false}
                        resizeingCol={false}
                      />
                    ) : (
                      <div className="NoData">No Records Found</div>
                    )}
                    {/* {loader ? (
                      <div className="">
                        <ThreeDots
                          visible={true}
                          height="80"
                          width="80"
                          color="#4fa94d"
                          radius="9"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    ) : 204 == searchDataSptf?.statusCode ? (
                      <div className="NoData">No Records Found</div>
                    ) : rows?.length > 0 ? (
                      <TableComponent
                        columns={columns}
                        rows={rows?.map((row, index) => ({
                          ...row,
                          index: index + 1,
                        }))}
                        sorting={true}
                        dragdrop={false}
                        fixedColumnsOn={false}
                        resizeingCol={false}
                      />
                    ) : null} */}
                  </div>

                  <button
                    class="SubmitBtn"
                    // onClick={handleViewMore}
                    disabled={
                      !rows || rows.length % 20 !== 0 || rows.length <= 0
                    }
                  >
                    View More
                  </button>
                </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
}

export default CreateSptf;
